import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    updateQuery(event) {
        const search = event.target.checked;
        const urlSearchParams = new URLSearchParams(window.location.search);

        if (search) {
            urlSearchParams.set('_my_discounts', search ? '1' : '0');
        } else {
            urlSearchParams.delete('_my_discounts');
        }

        urlSearchParams.delete('page');

        Turbo.visit(location.pathname + '?' + urlSearchParams);
    }
}
